import { useEffect, useState } from "react";
import { ExternalLink, X } from "lucide-react";

export default function IframeBanner() {
  const [inIframe, setInIframe] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    try {
      setInIframe(window.self !== window.top);
    } catch (_) {
      setInIframe(true);
    }
  }, []);

  if (!inIframe || dismissed) return null;

  const url = window.location.href;

  return (
    <div
      className="bg-gold/10 border-b border-gold/30 px-6 lg:px-12 py-3 text-sm text-white/85 flex items-center justify-between gap-4 flex-wrap"
      data-testid="iframe-banner"
    >
      <div className="flex items-center gap-2">
        <span className="text-gold">ⓘ</span>
        <span>
          Stai usando l'anteprima. Per aprire i lotti su Catawiki senza problemi,
          <a
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            className="ml-1.5 underline decoration-gold underline-offset-2 hover:text-gold inline-flex items-center gap-1"
            data-testid="open-standalone"
          >
            apri l'app in una nuova scheda
            <ExternalLink className="w-3 h-3" />
          </a>
          .
        </span>
      </div>
      <button
        type="button"
        onClick={() => setDismissed(true)}
        className="text-white/40 hover:text-white"
        aria-label="Chiudi"
        data-testid="iframe-banner-close"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
}
